export default {
  XSMALL_SMALL: 576,
  SMALL_MEDIUM: 768,
  MEDIUM_LARGE: 992,
  LARGE_XLARGE: 1200,
}